import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlineCheckCircle } from 'react-icons/hi';
import { HiArrowRight } from 'react-icons/hi2';

function SetupComplete() {
  const navigate = useNavigate();
  const schoolName = localStorage.getItem('schoolName') || 'Your School';
  const sections = JSON.parse(localStorage.getItem('sections') || '[]');

  return (
    <div className="min-h-screen auth-pattern-bg flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-md text-center">

        {/* Step Indicator */}
        <div className="flex items-center gap-2 mb-8">
          <div className="w-8 h-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center text-sm font-bold">1</div>
          <div className="flex-1 h-1 bg-blue-500 rounded"></div>
          <div className="w-8 h-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center text-sm font-bold">2</div>
          <div className="flex-1 h-1 bg-blue-500 rounded"></div>
          <div className="w-8 h-8 rounded-full bg-blue-500 text-white flex items-center justify-center text-sm font-bold">3</div>
        </div>

        {/* Success Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
            <HiOutlineCheckCircle className="text-green-500 text-5xl" />
          </div>
        </div>

        {/* Heading */}
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          You're all set!
        </h1>
        <p className="text-gray-500 mb-6">
          <span className="font-semibold text-blue-600">{schoolName}</span> has been set up successfully with {sections.length} section{sections.length !== 1 ? 's' : ''}.
        </p>

        {/* Sections Summary */}
        <div className="bg-gray-50 rounded-xl p-4 mb-8 text-left">
          <p className="text-sm font-semibold text-blue-700 mb-3">Sections created:</p>
          <div className="space-y-2">
            {sections.map((section) => (
              <div key={section.id} className="flex items-center gap-2">
                <span className="bg-blue-100 text-blue-700 text-xs font-bold px-2 py-1 rounded-lg">
                  {section.initials}
                </span>
                <span className="text-gray-700 text-sm font-medium">{section.name}</span>
                <span className="text-gray-400 text-xs ml-auto">{section.fields.length} fields</span>
              </div>
            ))}
          </div>
        </div>

        {/* Go to Dashboard */}
        <button
          onClick={() => navigate('/dashboard')}
          className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 rounded-xl transition-all flex items-center justify-center gap-2"
        >
          Go to Dashboard
          <HiArrowRight className="text-lg" />
        </button>

      </div>
    </div>
  );
}

export default SetupComplete;
